import ApiService from './ApiService';

const VerifyService = {
  async verify(id: number, verifyCode: { code: string }): Promise<any> {
    const response = await ApiService.post(`/v1/auth/two-factor/${id}/verify`, verifyCode);
    return response;
  },
};

export default VerifyService;
